<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">{{ 'study-editor.change-plot-entry-modal.title' | translate }}</h4>
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <div class="row mb-3">
            <div class="col-xs-12 col-md-12">
                <span class="fw-bold">
                    <span class="badge rounded-pill bg-secondary fs-6">{{numberOfPlots}}</span>
                    {{'study-editor.planting-preparation.modal.plots-selected-for' | translate}}
                    <span class="badge rounded-pill bg-secondary fs-6">{{numberOfInstances}}</span>
                    {{'study-editor.planting-preparation.modal.instances' | translate}}
                </span>
            </div>
        </div>
        <div class="container-fluid mt-3 ps-0 pe-0">
            <!-- Germplasm Entry Table Section -->
                <div class="row">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="col d-flex align-items-center">
                            <label class="col-auto" jhiTranslate="global.records.per.page">Records per page: </label>
                            <div class="col-1 ms-2">
                                <select class="form-select form-select-sm"
                                        [(ngModel)]="pageSize"
                                        (change)="onPageSizeChange($event)">
                                    <option value="50">50</option>
                                    <option value="75">75</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                        <div clas="col d-flex align-items-center">
                            <div class="d-inline-block me-3">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="changePlotEntryflexSwitchCategoricalDescriptionView" [(ngModel)]="isCategoricalDescriptionView">
                                    <label class="form-check-label" for="changePlotEntryflexSwitchCategoricalDescriptionView" jhiTranslate="study-editor.germplasm-checks.show.categorical.desc">Show Categorical Description</label>
                                </div>
                            </div>
                            @if (entries?.length && hasAnyAuthority(MODIFY_COLUMNS_PERMISSIONS)) {
                                <jhi-column-selector [container]="null"
                                                     [disabled]="isLoading"
                                                     [displayedColumns]="displayedColumns"
                                                     [columnDataService]="columnDataService"
                                                     (reset)="onColumnSelectorReset()"
                                                     (changed)="onColumnSelectoChange($event)"></jhi-column-selector>
                            }
                        </div>
                    </div>
                </div>
                <!-- Data Table -->
                <div class="table-responsive mt-3">
                    <div class="custom-scroll-style" style="min-height:500px; max-height: 500px; overflow-y: auto; overflow-x: auto;">
                        <table id="germplasm-checks-table"
                               class="table table-striped table-bordered table-curved">
                            <thead class="sticky-header">
                            <tr cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropColumn($event)">
                                @for (column of displayedColumns; track trackColumnsById(column)) {
                                    @if (column.selected && column.visible) {
                                        <th cdkDrag cdkDragHandle [ngClass]="getColumnClass(column)">
                                            @if (getStaticColumnLabelKey(column.termId)) {
                                                {{ getStaticColumnLabelKey(column.termId) | translate }}
                                            } @else {
                                                {{ column.displayName || column.name }}
                                            }

                                            @if (column.termId !== RADIO) {
                                                <span class="cursor-pointer ms-1"
                                                      #p="ngbPopover"
                                                      (click)="showColumnFilterPopover(column, p)"
                                                      [autoClose]="'outside'"
                                                      [ngbPopover]="columnFilterTemplate"
                                                      [placement]="['bottom', 'right', 'auto']"
                                                      triggers="manual">
                                    <i class="fa fa-filter ps-1" [ngClass]="{'filtering-by': column.isFiltered}"></i>
                                                    @if (column.sortingAsc !== undefined && column.sortingAsc !== null) {
                                                        <i class="ps-1 fa fa-icon-active"
                                                           [ngClass]="{'fa-sort-asc': column.sortingAsc, 'fa-sort-desc': !column.sortingAsc}">
                                        </i>
                                                    }
                                </span>
                                            }
                                        </th>
                                    }

                                }
                            </tr>
                            </thead>
                            <tbody>
                                @if (entries.length !== 0) {
                                    @for (entry of entries; track trackRowsById(entry); let row = $index) {
                                        <tr
                                                (click)="toggleSelect($event, row, entry); $event.stopPropagation()"
                                                [class.selected]="isSelected(entry.entryId)"
                                                (mousedown)="$event.preventDefault()"
                                                (contextmenu)="handleContextMenu($event)">
                                            @for (column of displayedColumns; track trackColumnsById(column); let col = $index) {
                                                <td *ngIf="column.selected && column.visible"
                                                    [class.number-cell]="variableDataTypeIs(column, DataTypeEnum.NUMERIC)"
                                                    [class.date-cell]="variableDataTypeIs(column, DataTypeEnum.DATE)"
                                                    [class.categorical-cell]="variableDataTypeIs(column, DataTypeEnum.CATEGORICAL)"
                                                    [class.error-cell]="getCellData(row, col)?.hasError"
                                                    [ngClass]="getCellClass(entry, column)">

                                                    @switch (true) {
                                                        @case (column.termId === RADIO) {
                                                            <input type="radio" class="form-check-input m-1"
                                                                   [checked]="isSelected(entry.entryId)"
                                                                   (change)="toggleSelect($event, row, entry, true)"
                                                                   (click)="$event.stopPropagation()"/>
                                                        }
                                                        @case (ACTIVE_LOT === column.termId) {
                                                            @if (entry.lotCount) {
                                                                <a href="javascript:void(0)" class="link" (click)="openInventoryDetails(entry.gid)">
                                                                    {{ entry.lotCount }}
                                                                </a>
                                                            } @else {
                                                                <span>-</span>
                                                            }
                                                        }
                                                        @case (AVAILABLE === column.termId) {
                                                            @if (entry.availableBalance) {
                                                                {{ entry.availableBalance }}
                                                            } @else {
                                                                <span>-</span>
                                                            }
                                                        }
                                                        @case (UNIT === column.termId) {
                                                            @if (entry.unit) {
                                                                {{ entry.unit }}
                                                            } @else {
                                                                <span>-</span>
                                                            }
                                                        }
                                                        @case (CROSS === column.termId) {
                                                            @if (entry.cross) {
                                                                {{ entry.cross }}
                                                            } @else {
                                                                <span>-</span>
                                                            }
                                                        }
                                                        @case (GROUPGID === column.termId) {
                                                            @if (entry.groupGid) {
                                                                <a  href="javascript:void(0)" (click)="openGermplasmDetailsAsNewTab(entry.groupGid)">
                                                                    {{ entry.groupGid }}
                                                                </a>
                                                            } @else {
                                                                <span>-</span>
                                                            }
                                                        }
                                                        @default {
                                                            @if (entry.properties[column.termId]) {
                                                                @if ([GID, DESIGNATION].includes(column.termId)) {
                                                                    @if (hasViewGermplasmDetailsPermission) {
                                                                        <a class="link" (click)="openGermplasmDetailsAsNewTab(entry.gid)">
                                                                            <truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'name':isCategoricalDescriptionView" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                                        </a>
                                                                    } @else {
                                                                        <truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'name':isCategoricalDescriptionView" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                                    }
                                                                } @else if ([MALE_PARENT_GID, MALE_PARENT_NAME].includes(column.termId)) {
                                                                    @if (MALE_PARENT_GID === column.termId && entry.properties[MALE_PARENT_GID]?.values) {
                                                                        <jhi-expandable-cell [data]="entry.properties[MALE_PARENT_GID]?.values"
                                                                                             [asLink]="hasViewGermplasmDetailsPermission"
                                                                                             (itemClick)="openGermplasmDetailsAsNewTab(entry.properties[MALE_PARENT_GID]?.values[$event])" ></jhi-expandable-cell>
                                                                    }
                                                                    @if (MALE_PARENT_NAME === column.termId && entry.properties[MALE_PARENT_NAME]?.values) {
                                                                        <jhi-expandable-cell [data]="entry.properties[MALE_PARENT_NAME]?.values"
                                                                                             [asLink]="hasViewGermplasmDetailsPermission"
                                                                                             (itemClick)="openGermplasmDetailsAsNewTab(entry.properties[MALE_PARENT_GID]?.values[$event])" ></jhi-expandable-cell>
                                                                    }
                                                                } @else if ([FEMALE_PARENT_GID, FEMALE_PARENT_NAME].includes(column.termId)) {
                                                                    @if (FEMALE_PARENT_GID === column.termId && entry.properties[FEMALE_PARENT_GID]?.values) {
                                                                        <jhi-expandable-cell [data]="entry.properties[FEMALE_PARENT_GID]?.values"
                                                                                             [asLink]="hasViewGermplasmDetailsPermission"
                                                                                             (itemClick)="openGermplasmDetailsAsNewTab(entry.properties[FEMALE_PARENT_GID]?.values[$event])" ></jhi-expandable-cell>
                                                                    }
                                                                    @if (FEMALE_PARENT_NAME === column.termId && entry.properties[FEMALE_PARENT_NAME]?.values) {
                                                                        <jhi-expandable-cell [data]="entry.properties[FEMALE_PARENT_NAME]?.values"
                                                                                             [asLink]="hasViewGermplasmDetailsPermission"
                                                                                             (itemClick)="openGermplasmDetailsAsNewTab(entry.properties[FEMALE_PARENT_GID]?.values[$event])" ></jhi-expandable-cell>
                                                                    }
                                                                } @else if ([BREEDING_METHOD_ABBR].includes(column.termId)) {
                                                                    <a (click)="$event.stopPropagation()"
                                                                       [routerLink]="['/', { outlets: { popup: 'breeding-method-by-code/' + entry.properties[BREEDING_METHOD_ABBR]?.value } }]"
                                                                       [queryParams]="this.paramContext.toQueryParams()">
                                                                        {{ getCellValue(entry, column) | categoricalDisplayValue:column:'name':isCategoricalDescriptionView }}
                                                                    </a>
                                                                } @else {
                                                                    <truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'name':isCategoricalDescriptionView" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                                }
                                                            }
                                                        }
                                                    }
                                                </td>
                                            }
                                        </tr>
                                    }
                                } @else {
                                    <tr>
                                        <td [attr.colspan]="displayedColumns.length" class="text-center py-3">
                                            {{ 'study-editor.no-records' | translate }}
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-3">

                    <div>
                        @if (numberOfEntries !== numberOfFilteredEntries) {
                            <span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
								[translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredEntries), param3: numberOfFilteredEntries}"></span>
                            <span class="text-muted" jhiTranslate="study-editor.pagination.entry-total-count" [translateValues]="{param: numberOfEntries}"></span>
                        } @else {
                            <span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
								  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredEntries), param3: numberOfEntries}"></span>
                        }
                    </div>

                    <div>
                        <div class="d-inline-block ms-3">
                            <ngb-pagination
                                    [collectionSize]="numberOfFilteredEntries || numberOfEntries"
                                    [(page)]="currentPage"
                                    [pageSize]="pageSize"
                                    [maxSize]="10"
                                    [ellipses]="true"
                                    [boundaryLinks]="true"
                                    [rotate]="true"
                                    (pageChange)="onPageChange($event)">
                            </ngb-pagination>
                        </div>
                        <div class="d-inline-block ms-3">
                            <label for="goToPage" class="me-2" jhiTranslate="study-editor.pagination.go-to">Go to page:</label>
                            <input id="goToPage" type="number" class="form-control d-inline-block w-auto"
                                   [min]="1" [max]="Math.ceil((numberOfFilteredEntries || numberOfEntries) / pageSize)"
                                   [(ngModel)]="currentPage"
                                   (change)="onPageChange(currentPage); $event.preventDefault()"/>
                        </div>
                    </div>
                </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancel()">{{ 'cancel' | translate}}</button>
        <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="!valid()">{{ 'confirm' | translate}}</button>
    </div>
</div>

<!-- Column Filter Template -->
<ng-template #columnFilterTemplate>
    <div class="column-filter">
        <!-- Sorting Buttons -->
        <div class="btn-group w-100" role="group" *ngIf="columnDataForFilter.enableFilterSorting !== false">
            <button (click)="sortColumn(columnDataForFilter,true)" class="btn btn-o"
                    [ngClass]="columnDataForFilter.sortingAsc === true ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-asc fw-bold fs-6"></i>
            </button>
            <button (click)="sortColumn(columnDataForFilter,false)" class="btn"
                    [ngClass]="columnDataForFilter.sortingAsc === false ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-desc fw-bold fs-6"></i>
            </button>
        </div>
        <!-- Regular Input Filter -->
        <div *ngIf="columnDataForFilter.dataTypeCode !== 'D'" class="mt-2">
            <input class="form-control"
                   [(ngModel)]="columnDataForFilter.query"
                   placeholder="{{ 'common.filter.value' | translate }}"
                   [title]="columnDataForFilter.possibleValues?.length ? ('study-editor.study-dataset.no.values.filter.title' | translate) : ''">

            <!-- Filter Options List -->
            <ul class="list-group mt-3" *ngIf="columnDataForFilter.possibleValues">
                <li class="list-group-item" *ngIf="!columnDataForFilter.query">
                    <div class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [(ngModel)]="columnDataForFilter.isSelectAll"
                               (change)="filterSelectAll(columnDataForFilter, columnDataForFilter.isSelectAll)">
                        <label class="form-check-label" jhiTranslate="global.select.all.items">Select all</label>
                    </div>
                </li>
                <li *ngFor="let option of columnDataForFilter.possibleValues | orderBy:'name' | filter:columnDataForFilter.query:'name'"
                    class="list-group-item">
                    <div class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [(ngModel)]="option.isSelectedInFilters"
                               (change)="filterSelectOption(option.isSelectedInFilters)">
                        <label class="form-check-label">
                            {{ isCategoricalDescriptionView ? option.displayDescription : option.displayValue }}
                        </label>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Date Filter -->
        <div *ngIf="columnDataForFilter.dataTypeCode === 'D'" class="mt-3">
            <input class="form-control"
                   [(ngModel)]="columnDataForFilter.query"
                   ngbDatepicker="dp"
                   placeholder="{{ 'common.filter.value' | translate }}">
            <div class="mt-3">
                <ngb-datepicker #dp
                                [(ngModel)]="columnDataForFilter.query"
                                class="well well-sm"
                                (click)="$event.stopPropagation()">
                </ngb-datepicker>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="mt-3">
            <div class="d-flex justify-content-around">
                <div>
                    <button class="btn btn-info ms-2"
                            (click)="filterByColumn(columnDataForFilter)"
                            title="{{ 'global.apply.all.filter' | translate }}" jhiTranslate="apply">
                        Apply
                    </button>
                    <button class="btn btn-secondary ms-2"
                            (click)="resetFilterByColumn(columnDataForFilter)"
                            title="{{ 'global.reset.filter' | translate }}" jhiTranslate="reset">
                        Reset
                    </button>
                </div>
            </div>
        </div>
    </div>

</ng-template>
